import { useCallback } from 'react';
import useDropdownOptions from 'hooks/useDropdownOptions';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { fieldOptions } from '../utils/subscriptionConsts';

const msgFieldPrefix = 'push.api.create.settings.field';

export const useFieldWithKey = (entityKey, fieldKey) => {
    const options = useDropdownOptions(fieldOptions, msgFieldPrefix);
    const { value: field, onChange: setField } = useFormFieldValue({
        field: `entities.${entityKey}.fields.${fieldKey}.name`,
        isAbsolute: true,
    });

    const setFieldOnChange = useCallback(
        ({ value: field }) => {
            setField(field);
        },
        [setField]
    );
    return { options, field, setFieldOnChange };
};
